var path = 'src/app/forms/control.html';
var html = "<div ng-class=\"{'col-md-9': horizontal, 'col-sm-offset-3': !hasLabel && horizontal}\" ng-transclude></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/control.html
 ** module id = 315
 ** module chunks = 0
 **/